import React from "react"
import styled from "styled-components"
import CommonText from "@/components/common/Text"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Text = styled(CommonText)`
	width: 62.5%;
	font-weight: ${({ theme }) => theme.fontWeight.semiBold};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		width: 60%;
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: 100%;
	}
`

const TightHeader = ({ header, color }) => {
	return (
		<>
			<Text color={color} tag="h2" className="typo-borna typo-borna-40 header">
				{header}
			</Text>
		</>
	)
}

export default TightHeader
